/**
 * Polska zawartość katalogu kopii dla funkcji `community` (fora, wątki, Sala
 * Legend). Klucze odbijają wywołania `t('community.*')` w
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityPl = {
  // CommunityPage
  'community.page.seoTitle': 'Społeczność',
  'community.page.seoDescription':
    'Dołącz do społeczności Grymwyrd: fora, teorie wiedzy, narzędzia dla MG, homebrew i Sala Legend.',
  'community.page.eyebrow': 'Zebranie Mroku',
  'community.page.title': 'Społeczność',
  'community.page.intro':
    'Dziel się taktyką, snuj teorie, wymieniaj homebrew i wspinaj się ku kanonowi. Każdy post, który napiszesz, zdobywa monety i reputację w wiecznym mroku.',
  'community.page.loading': 'Zbieramy wiernych…',
  'community.page.forumCategories': 'Kategorie Forów',
  'community.page.categoryStats': '{threads} wątków · {posts} postów',
  'community.page.recentActivity': 'Ostatnia Aktywność',
  'community.page.liveFeed': 'kanał na żywo',
  'community.page.recentEmpty':
    'Fora są dziś cicho. Zacznij dyskusję, by obudzić umarłych.',
  'community.page.hallOfLegends': 'Sala Legend',
  'community.page.hallBlurb': 'Najznakomitsi wspóltwórcy i postacie, które ukuli w kanonie.',
  'community.page.enterTheHall': 'Wejdź do Sali',
  'community.page.playerSpotlights': 'Reflektory na Graczy',
  'community.page.summoningLegends': 'Przywołujemy legendy…',
  'community.page.sampleNotice': 'Wyświetlanie przykładowej zawartości społeczności podczas budzenia się forów.',

  // FlagButton
  'community.flag.errorQueued':
    'Nie mogliśmy teraz skontaktować się z moderatorami, ale twoja zgłoszenie zostało zakolejkowane.',
  'community.flag.ariaLabel': 'Zgłoś ten post do moderacji',
  'community.flag.label': 'Zgłoś',
  'community.flag.modalTitle': 'Zgłoś do Strażników',
  'community.flag.successDelivered':
    'Twoje zgłoszenie dotarło do moderatorów. Strażnicy wdzięczni Ci są.',
  'community.flag.close': 'Zamknij',
  'community.flag.signInNotice':
    'Możesz opisać problem, ale aby zgłoszenie dotarło do moderatorów, musisz być zalogowany.',
  'community.flag.whyFlagging': 'Dlaczego zgłaszasz ten post?',
  'community.flag.reason.spamOrAdvertising': 'Spam lub reklama',
  'community.flag.reason.harassmentOrAbuse': 'Molestowanie lub znęcanie się',
  'community.flag.reason.spoilersWithoutWarning': 'Spojlery bez ostrzeżenia',
  'community.flag.reason.offTopic': 'Poza tematem',
  'community.flag.reason.otherDescribeBelow': 'Inne (opisz poniżej)',
  'community.flag.describeIssue': 'Opisz problem',
  'community.flag.detailPlaceholder': 'Powiedz Strażnikom, co jest nie tak…',
  'community.flag.cancel': 'Anuluj',
  'community.flag.reporting': 'Zgłaszamy…',
  'community.flag.submitReport': 'Wyślij zgłoszenie',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Fora',
  'community.category.seoDescription': 'Dyskusje na forum {name} na Grymwyrd.',
  'community.category.breadcrumb': 'Społeczność',
  'community.category.entityTiedPrefix': 'Tablica powiązana z jednostką · wątki mogą odwoływać się do',
  'community.category.encyclopediaEntries': 'wpisów encyklopedii',
  'community.category.sampleNotice': 'Wyświetlanie przykładowych wątków podczas budzenia się forum.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Sala Legend',
  'community.legends.seoDescription':
    'Najznakomitsi wspóltwórcy Grymwyrd i postacie, które ukuli w kanonie.',
  'community.legends.breadcrumb': 'Społeczność',
  'community.legends.title': 'Sala Legend',
  'community.legends.intro':
    'Tu stoją architekci wiecznego mroku — wspóltwórcy, których słowa stały się prawem, i postacie tak umiłowane, że wyrzeźbiono je w kanonie.',
  'community.legends.loading': 'Zapalamy świece…',
  'community.legends.topContributors': 'Najlepsi Wspóltwórcy',
  'community.legends.noContributors':
    'Jeszcze żadne legendy się nie wzniosły. Pisz, snuj teorie i twórz, by zarezerwować sobie miejsce.',
  'community.legends.canonizedCharacters': 'Skanonizowane Postacie',
  'community.legends.noCharacters':
    'Jeszcze żadne postacie nie zostały skanonizowane. Bestiariusz czeka na kolejny koszmar.',
  'community.legends.sampleNotice': 'Wyświetlanie przykładowych legend podczas poświęcania żywej sali.',

  // NestedReplies
  'community.replies.replyBy': 'Odpowiedź od {author}',
  'community.replies.reply': 'Odpowiedź',
  'community.replies.replyToPlaceholder': 'Odpowiedz {author}…',
  'community.replies.unlike': 'Nie lubię tego posta',
  'community.replies.like': 'Lubię ten post',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} reputacji',
  'community.spotlight.viewInEncyclopedia': 'Wyświetl {name} w encyklopedii',

  // PostComposer
  'community.composer.placeholder': 'Dodaj swój głos do mroku…',
  'community.composer.signInPrompt': 'Zaloguj się, aby wziąć udział w dyskusji i zarabić monety za swoje słowa.',
  'community.composer.signInToReply': 'Zaloguj się, aby odpowiedzieć',
  'community.composer.youFallback': 'Ty',
  'community.composer.saveError':
    'Twoja odpowiedź nie mogła być zapisana na serwerze — wyświetlana jest tylko lokalnie.',
  'community.composer.writeReply': 'Napisz odpowiedź',
  'community.composer.writePost': 'Napisz post',
  'community.composer.replyText': 'Tekst odpowiedzi',
  'community.composer.postText': 'Tekst posta',
  'community.composer.posting': 'Wysyłamy…',
  'community.composer.postReply': 'Wyślij odpowiedź',
  'community.composer.post': 'Wyślij',
  'community.composer.cancel': 'Anuluj',
  'community.composer.coinsPerPost': '+{count} monet za post',
  'community.composer.coinsEarned': '+{count} monet zarobionych za twój post!',

  // ThreadItem
  'community.thread.pinned': 'Wątek przypięty',
  'community.thread.byPrefix': 'od',
  'community.thread.repliesTitle': '{count} odpowiedzi',
  'community.thread.likesTitle': '{count} polubień',
  'community.thread.viewsTitle': '{count} odsłon',
  'community.thread.entityEntry': 'wpis {type}',

  // ThreadList
  'community.threadList.empty':
    'Żadne dyskusje nie wybuchły tu jeszcze. Bądź pierwszy i przełam milczenie.',

  // ThreadPage
  'community.threadPage.loading': 'Odsieglowujemy wątek…',
  'community.threadPage.seoDescription': 'Dyskusja na forach społeczności Grymwyrd.',
  'community.threadPage.replyCount': '{count} odpowiedzi',
  'community.threadPage.opened': 'otwarte {time}',
  'community.threadPage.entityEntry': 'wpis {type}',
  'community.threadPage.sampleNotice': 'Wyświetlanie przykładowej dyskusji podczas budzenia się forum.',
  'community.threadPage.openingPostBy': 'Post otwierający od {author}',
  'community.threadPage.repliesHeading': 'Odpowiedzi',
  'community.threadPage.noReplies': 'Jeszcze brak odpowiedzi. Bądź pierwszy i odpowiedz na wezwanie.',
  'community.threadPage.addYourReply': 'Dodaj swoją odpowiedź',
} as const
